export enum RouteName {
  List = 'organization-group-list',
  Create = 'organization-group-create',
  Edit = 'organization-group-edit',
  Details = 'organization-group-details',
}
